// 通过 userAgent 获取当前系统语言
const ua = navigator.userAgent;
// TODO：lang不一定只有这俩
const lang = /locale\/id/.test(ua) ? 'id' : 'en';

export default lang;
